var render = function render(){var _vm=this,_c=_vm._self._c;return _c('filter-controller',{attrs:{"receive":_vm.allProps.receive,"all":_vm.allProps.result,"pagination":_vm.pagination,"loading":_vm.allProps.loading,"value":_vm.value,"label":_vm.label,"needSearch":_vm.needSearch,"searchHint":_vm.searchHint},on:{"input":_vm.handleFilter}})
}
var staticRenderFns = []

export { render, staticRenderFns }